export const dataSourceItems =
{
    sourceId: "1",
    sourceName: "Salesforce",
    dataMethod: { id: "GET", name: "GET" },
    dataUrl: "http://source.salesforcetonetsuite.com/test",
    headersdata: [{ headerKey: 1, headervalue: "Headers1" }, { headerKey: 2, headervalue: "Headers2" }, { headerKey: 3, headervalue: "Headers3" }],
    authenticationtype: { id: "basic_auth", name: "Basic Authentication" },
    authenticationsettings: [{ auth_Username: 'Test', auth_password: "Test@123" }],
    paginationtype: { id: "offset_pagination", name: "Offset Pagination" },
    paginationsettings: [{ pagination_user_key: 'Test' }],
    pipelinetype: { id: "interval", name: "Interval" },
    pipelinesettings: [{ pipeline_frequencyinterval: "2 hrs" }],
    timeelementsettings: [
        {
            pagination_timeelement_today_format: "%Y-%m-%dT00:00:01Z",
            pagination_timeelement_yesterday_format: "%Y-%m-%dT00:00:01Z",
            pagination_timeelement_rolling_time_format: "%Y-%m-%dT%H:%M:00.000",
            pagination_timeelement_rolling_frequency: ""
        }
    ],
    body: "test"
}


